import { FilterTypeKey, FilterType, INumberFilter, IStringFilter, IEnumFilter } from '../../components/filters';
import { performanceFilters } from '../../components/filters/perfomance.filter';

export const channelFilters = new Map<FilterTypeKey, FilterType>([
	['numberFilters', { ...performanceFilters.numberFilters } as INumberFilter],
	['stringFilters', { ...performanceFilters.stringFilters, name: { columnName: 'Channel', cellKey: 'channel' } } as IStringFilter],
	[
		'enumFilters',
		{
			...performanceFilters.enumFilters,
		} as IEnumFilter,
	],
]);
